(function() {
    'use strict';

    angular.module('dealerware').constant('loginPath', '/login');

    angular.module('dealerware').constant('routeShortcuts', {
        notAuthorized: {
            target: 'root.public.content.error.authorization',
            params: {}
        },
        confirmAccount: {
            target: 'root.public.content.confirmAccount',
            params: { confirmation_token: null }
        },
        resetPassword: {
            target: 'root.public.content.resetPassword',
            params: { reset_password_token: null }
        },
        login: {
            target: 'root.public.content.login',
            params: {}
        },
        loading: {
            target: 'root.public.content.loading',
            params: {}
        },
        logout: {
            target: 'root.private.logout',
            params: {}
        },
        chooseLocation: {
            target: 'root.private.application.chooseLocation',
            params: { afterLogin: null, forwardState: null }
        },
        locationSummary: {
            target: 'root.private.application.locations.location.summary',
            params: { afterLogin: null }
        },
        locationAddress: {
            target: 'root.private.application.locations.location.address',
            params: { afterLogin: null }
        },
        locationDetails: {
            target: 'root.private.application.locations.location.details',
            params: { afterLogin: null }
        },
        locationDaysOfOperation: {
            target: 'root.private.application.locations.location.daysOfOperation',
            params: { afterLogin: null }
        },
        settings: {
            target: 'root.private.application.settings',
            params: { afterLogin: null }
        },
        settingsLocationWizard: {
            target: 'root.private.application.settings.accountActivationWizard',
            params: {}
        },
        settingsLoanerAgreement: {
            target: 'root.private.application.settings.loanerAgreement.view',
            params: { afterLogin: null }
        },
        settingsLoanerAgreementUpload: {
            target: 'root.private.application.settings.loanerAgreement.upload',
            params: { afterLogin: null }
        },
        settingsLoanerAgreementSelectPage: {
            target: 'root.private.application.settings.loanerAgreement.selectPage',
            params: { afterLogin: null }
        },
        settingsLoanerAgreementSetSignature: {
            target: 'root.private.application.settings.loanerAgreement.setSignature',
            params: { afterLogin: null }
        },
        settingsLoanerAgreementSetDate: {
            target: 'root.private.application.settings.loanerAgreement.setDate',
            params: { afterLogin: null }
        },
        settingsLoanerAgreementView: {
            target: 'root.private.application.settings.loanerAgreement.view',
            params: { afterLogin: null }
        },
        settingsLoanerAgreementSummary: {
            target: 'root.private.application.settings.loanerAgreementSummary',
            params: { afterLogin: null }
        },
        settingsFleetUpload: {
            target: 'root.private.application.settings.fleetUpload',
            params: { afterLogin: null }
        },
        settingsExpenses: {
            target: 'root.private.application.settings.expenses',
            params: { afterLogin: null }
        },
        settingsWebhooks: {
            target: 'root.private.application.settings.webhooks',
            params: { afterLogin: null }
        },
        settingsLocations: {
            target: 'root.private.application.locations',
            params: { afterLogin: null }
        },
        settingsApiDocs: {
            target: 'root.private.application.training.apiDocs',
            params: { afterLogin: null }
        },
        reportsInventory: {
            target: 'root.private.application.reports.inventory',
            params: { afterLogin: null }
        },
        reportsUtilization: {
            target: 'root.private.application.reports.utilization',
            params: { afterLogin: null }
        },
        reportsContracts: {
            target: 'root.private.application.reports.contracts',
            params: { afterLogin: null }
        },
        reportsTransactions: {
            target: 'root.private.application.reports.transactions',
            params: { afterLogin: null }
        },
        reportsTolls: {
            target: 'root.private.application.reports.tolls',
            params: { afterLogin: null }
        },
        dashboard: {
            target: 'root.private.application.dashboard',
            params: {}
        },
        employeesDashboard: {
            target: 'root.private.application.employees.dashboard',
            params: {}
        },
        employeeDetails: {
            target: 'root.private.application.employees.details',
            params: { employeeId: null }
        },
        customersDashboard: {
            target: 'root.private.application.customers.dashboard',
            params: {}
        },
        customerDetails: {
            target: 'root.private.application.customers.details',
            params: { customerId: null, pageId: null }
        },
        contractsDashboard: {
            target: 'root.private.application.contracts.dashboard',
            params: {}
        },
        contractDetails: {
            target: 'root.private.application.contracts.details',
            params: { contractId: null }
        },
        contractDetailsDetails: {
            target: 'root.private.application.contracts.details.details',
            params: { contractId: null }
        },
        contractDriversLicense: {
            target: 'root.private.application.contracts.details.driversLicense',
            params: { contractId: null }
        },
        contractAdditionalDrivers: {
            target: 'root.private.application.contracts.details.additionalDrivers',
            params: { contractId: null }
        },
        contractInsurance: {
            target: 'root.private.application.contracts.details.insurance',
            params: { contractId: null }
        },
        contractNotes: {
            target: 'root.private.application.contracts.details.notes',
            params: { contractId: null }
        },
        contractVehicles: {
            target: 'root.private.application.contracts.details.vehicles',
            params: { contractId: null }
        },
        contractPricing: {
            target: 'root.private.application.contracts.details.pricing',
            params: { contractId: null }
        },
        contractVehicleIssues: {
            target: 'root.private.application.contracts.details.vehicleIssues',
            params: { contractId: null }
        },
        contractCreate: {
            target: 'root.private.application.contracts.create',
            params: { customerId: null }
        },
        contractConfirmation: {
            target: 'root.private.application.contracts.confirmation',
            params: { contractId: null }
        },
        vehiclesDashboard: {
            target: 'root.private.application.vehicles.dashboard',
            params: { searchText: null }
        },
        vehicleDetails: {
            target: 'root.private.application.vehicles.details',
            params: { vehicleId: null }
        },
        vehicleScanHistory: {
            target: 'root.private.application.vehicles.details.vehicleScanHistory',
            params: { vehicleId: null }
        },
        vehicleQrCodes: {
            target: 'root.private.application.vehicles.qrcodes',
            params: {}
        },
        dealerwareHelp: {
            target: 'external.dealerwareHelp',
            params: {}
        },
        dealerwareAcademy: {
            target: 'external.dealerwareAcademy',
            params: {}
        },
        dealerwareContactUs: {
            target: 'external.dealerwareContactUs',
            params: {}
        },
        dealerwarePlaceOrder: {
            target: 'external.dealerwarePlaceOrder',
            params: {}
        }
    });

    angular.module('dealerware').value('reverseRouteShortcuts', { });

    angular.module('dealerware').config(function($stateProvider, $urlRouterProvider, loginPath, routeShortcuts) {

        var _defaultState = '/',
            _resolvers = {
                loggedIn: ['CurrentUser', '$state', '$q', function(CurrentUser, $state, $q) {
                    var _deferred = $q.defer();

                    CurrentUser.loadCurrentUser().then(
                        function() {
                            if (CurrentUser.isLoggedIn()) {
                                _deferred.resolve();
                            } else {
                                $state.go('shortcuts.login');
                                _deferred.reject();
                            }
                        },
                        function() {
                            $state.go('shortcuts.login');
                            _deferred.reject();
                        }
                    );

                    return _deferred.promise;
                }]
            }

        /* ===================== Shortcut States ===================== */

        /*
            Shortcut states map to the below states. They are meant so that
            we can refer to the shortcut states in the app and if the real
            states change, we just update the shortcut link and the app
            continues to work without any other mods.
         */

        $stateProvider.state('shortcuts', {
            url: '/shortcuts',
            abstract: true
        });

        angular.forEach(routeShortcuts, function(val, key) {

            $stateProvider.state('shortcuts.' + key, {
                url: '/' + key,
                abstract: false,
                views: {},
                params: val.params,
                resolve: {
                    redirectToFinalState: ['$state', '$q', '$timeout', '$stateParams', function($state, $q, $timeout, $stateParams) {
                        var _deferred = $q.defer();

                        $timeout(function() {
                            $state.go(val.target,$stateParams);
                            _deferred.reject();
                        }, 0);

                        return _deferred.promise;
                    }]
                },
                data: {
                    target: val.target
                }
            });
        });


        /* ================ Base (root) State ===================== */

        $stateProvider.state('root', {
            url : '',
            abstract: true,
            templateUrl: '/layout/root/root_layout.html',
            controller: '$dealerwareRootLayoutController',
            controllerAs: 'rootController',
            data: {
                rootLayout: { layoutClass: 'dealerware' },
                page: { title: 'Dealerware' }
            }
        });

        /* =============== Access control states ================== */

        /*
            Public state -
              authentication  : no access control
              authorization   : none
         */
        $stateProvider.state('root.public', {
            url: '',
            abstract: true,
            views: {
                rootLayoutContent: {
                    templateUrl: '/layout/root/public/public_layout.html',
                    controller: '$dealerwarePublicLayoutController',
                    controllerAs: 'publicLayoutController'
                }
            },
            data: {
                publicLayout: { layoutClass: 'dealerware-public' },
                page: { title: 'Dealerware' }
            }
        });

        /*
          Private state
            authentication  : user must be logged in
            authorization   : user must have role defined in data:authorization:roles todo: implement
         */
        $stateProvider.state('root.private', {
            url: '',
            abstract: true,
            views: {
                rootLayoutContent: {
                    templateUrl: '/layout/root/private/private_layout.html',
                    controller: '$dealerwarePrivateLayoutController',
                    controllerAs: 'privateLayoutController'
                }
            },
            resolve: { loggedIn: _resolvers.loggedIn },
            data: {
                privateLayout: { layoutClass: 'dealerware-private' },
                page: { title: 'Dealerware' }
            }
        });


        /* =============== Content only states ================== */

        /*
            use one of the content states for content only
            No header or menu
         */
        $stateProvider.state('root.public.content', {
            url: '',
            abstract: true,
            views: {
                publicLayoutContent: {
                    templateUrl: '/layout/root/content/content_layout.html',
                    controller: '$dealerwareContentLayoutController',
                    controllerAs: 'contentLayoutController'
                }
            },
            data: {
                contentLayout: {
                    layoutClass: 'dealerware-content',
                    addPadding: true
                },
                page: { title: 'Dealerware' }
            }
        });

        $stateProvider.state('root.public.content.home', {
            url: '/',
            abstract: false,
            views: {
                contentContent: { template: '<h1>Home</h1>' }
            },
            data: {
                page: { title: 'Dealerware' }
            },
            resolve: {
                alreadyLoggedIn: ['CurrentUser', '$state', '$q', function(CurrentUser, $state, $q) {
                    var _deferred = $q.defer();

                    CurrentUser.loadCurrentUser().then(
                        function() {
                            if (CurrentUser.isLoggedIn()) {
                                $state.go('shortcuts.dashboard');
                                _deferred.reject();
                            } else {
                                $state.go('shortcuts.login');
                                _deferred.reject();
                            }
                        },
                        function() {
                            $state.go('shortcuts.login');
                            _deferred.reject();
                        }
                    );

                    return _deferred.promise;
                }]
            }
        });

        $stateProvider.state('root.public.content.theme', {
            url: '/theme',
            abstract: false,
            views: {
                contentLayoutContent: { templateUrl: '/content/theme/index.html' }
            },
            data: {
                page: { title: 'Silvercar Theme' }
            },
        });

        $stateProvider.state('root.public.content.loading', {
            url: '/loading',
            abstract: false,
            views: {
                contentLayoutContent: { templateUrl: '/content/loading/index.html' }
            },
            data: {
                page: { title: 'Loading' }
            }
        });

        $stateProvider.state('root.public.content.error', {
            url: '/error',
            abstract: true,
            views: {
                contentLayoutContent: {
                    template   : '<div ui-view="errorLayout"></div>',
                }
            },
        });

        $stateProvider.state('root.public.content.error.authorization', {
            url: '/authorization',
            abtract: false,
            views: {
                errorLayout: {
                    templateUrl   : '/content/errors/error.html',
                    controller    : function ($controller, $state) {
                        var controller = $controller('ErrorPageController');
                        controller.category    = 'Authorization';
                        controller.explanation = 'Sorry, we can\'t load the page you asked for.';
                        controller.remedies    = [
                            '<a href="' + $state.href('shortcuts.logout') + '" class="md-default-theme md-primary md-hue-2 md-fg">Logging out</a>,'
                                + ' then logging back in might fix the problem;',
                            'You might need to ask your administrator for more permissions.'
                        ];
                        return controller;
                    },
                    controllerAs  : 'errorPageController'
                }
            },
            data: {
                page: { title: 'Not Authorized' }
            }
        });

        $stateProvider.state('root.public.content.confirmAccount', {
            url: '/confirm-account?confirmation_token',
            abstract: false,
            views: {
                contentLayoutContent: {
                    controller: 'ConfirmAccountController',
                    controllerAs: 'confirmAccountController'
                }
            },
            resolve: {
                skipConfirmation: ['CurrentUser', '$state', '$q', '$stateParams', function(CurrentUser, $state, $q, $stateParams) {
                    var _deferred = $q.defer();

                    if (!$stateParams.confirmation_token) {
                        $state.go('shortcuts.dashboard');
                        _deferred.resolve();
                    } else {
                        _deferred.resolve();
                    }
                }]
            }
        });

        $stateProvider.state('root.public.content.resetPassword', {
            url: '/reset-password?reset_password_token',
            abstract: false,
            views: {
                contentLayoutContent: {
                    controller: 'ResetPasswordController',
                    controllerAs: 'resetPasswordController'
                }
            }
        });

        $stateProvider.state('root.public.content.login', {
            url: loginPath,
            abstract: false,
            views: {
                contentLayoutContent: {
                    templateUrl: '/content/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'loginPageController'
                }
            },
            data: {
                page: { title: 'Log in' }
            },
            resolve: {
                alreadyLoggedIn: ['CurrentUser', '$state', '$q', function(CurrentUser, $state, $q) {
                    var _deferred = $q.defer();

                    CurrentUser.user = undefined;
                    CurrentUser.managedCompanies = undefined;

                    CurrentUser.loadCurrentUser().then(
                        function() {
                            if (CurrentUser.isLoggedIn()) {
                                $state.go('shortcuts.dashboard');
                                _deferred.reject();
                            } else {
                                _deferred.resolve();
                            }
                        },
                        function() {
                            _deferred.resolve();
                        }
                    );

                    return _deferred.promise;
                }]
            }
        });

        // I think it's more appropriate to do /logout as a separate route:
        //
        //     1. You can get into non-authorized states where you're logged in but stuck
        //        on errorNotAuthorized with no way to log out without deleting cookies/localStorage
        //        and restarting the browser.  These are mainly edge cases, e.g. having roles
        //        removed out from under a user, while they're still logged in, but:
        //
        //     2. I'm generally for distinct states being handled as distinct routes.  We can
        //        imagine different things that we want to do on logout, so I think logically
        //        that makes logout eligible to be a first-class state.
        //
        $stateProvider.state('root.private.logout', {
            url: '/logout',
            abstract: false,
            views: {
                privateLayoutContent: {
                    controller: function ($controller) {
                        var logoutController = $controller('MobilityWebCoreSignOutLinkDirectiveController');
                        logoutController.successState = 'shortcuts.login';
                        logoutController.handleClick();
                    }
                }
            }
        });

        $stateProvider.state('root.private.content', {
            url: '',
            abstract: true,
            views: {
                privateLayoutContent: {
                    templateUrl: '/layout/root/content/content_layout.html',
                    controller: '$dealerwareContentLayoutController',
                    controllerAs: 'contentLayoutController'
                }
            },
            data: {
                contentLayout: {
                    layoutClass: 'dealerware-content',
                    addPadding: true
                },
                page: { title: 'Dealerware' }
            }
        });

        /* =============== Application states ================== */

        // these states have the side nav and the menu bar
        $stateProvider.state('root.public.application', {
            url: '',
            abstract: true,
            views: {
                publicLayoutContent: {
                    templateUrl: '/layout/root/application/application_layout.html',
                    controller: '$dealerwareApplicationLayoutController',
                    controllerAs : 'applicationLayoutController'
                }
            },
            data: {
                applicationLayout: { layoutClass: 'dealerware-application' },
                page: { title: 'Dealerware' }
            }
        });

        $stateProvider.state('root.private.application', {
            url: '',
            abstract: true,
            views: {
                privateLayoutContent: {
                    templateUrl: '/layout/root/application/application_layout.html',
                    controller: '$dealerwareApplicationLayoutController',
                    controllerAs : 'applicationLayoutController'
                }
            },
            data: {
                applicationLayout: { layoutClass: 'dealerware-application' },
                page: { title: 'Dealerware' }
            }
        });

        $stateProvider.state('root.private.application.chooseLocation', {
            url: '/chooseLocation',
            abstract: false,
            params: { afterLogin: null, forwardState: null },
            views: {
                applicationLayoutContent: {
                    templateUrl: '/content/login/location_chooser.html',
                    controller: 'LocationChooserController',
                    controllerAs: 'locationChooserController'
                }
            },
            resolve: {
                managedCompanies: (CurrentUser) => {
                    return CurrentUser.loadManagedCompanies();
                }
            },
            data: {
                page: { title: 'Select Location' }
            }
        });

        $stateProvider.state('root.private.application.locations', {
            url: '/locations',
            abstract: false,
            cache: false,
            views: {
                applicationLayoutContent: {
                    template: '<div ng-include="\'/content/locations/locations.html\'">',
                    controller: 'LocationsController',
                    controllerAs: 'locationsController'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { title: 'Locations' },
                requireCompany: true
            }
        });

        // Keeping this intermediate abstract route around, rather than just using absolute route resolution directly.
        //
        $stateProvider.state('root.private.application.locations.location', {
            url: '/:locationId',
            abstract: true,
            views: {
                'applicationLayoutContent@root.private.application': {
                    templateUrl: '/content/locations/location.html',
                    controller: 'LocationController',
                    controllerAs: 'locationController'
                }
            },
            data: {
                page: { title: 'Location' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.locations.location.summary', {
            url: '/summary',
            cache: false,
            abstract: false
        });

        $stateProvider.state('root.private.application.locations.location.address', {
            url: '/address',
            cache: false,
            abstract: false
        });

        $stateProvider.state('root.private.application.locations.location.details', {
            url: '/details',
            cache: false,
            abstract: false
        });

        $stateProvider.state('root.private.application.locations.location.daysOfOperation', {
            url: '/days_of_operation',
            cache: false,
            abstract: false
        });

        $stateProvider.state('root.private.application.settings', {
            url: '/settings',
            abstract: true,
            views: {
              applicationLayoutContent: {
                  template: '<div ui-view="settingsContent"></div>'
              }
          },
        });

        $stateProvider.state('root.private.application.settings.accountActivationWizard', {
            url: '/account_activation',
            abstract: false,
            cache: false,
            views: {
                settingsContent: {
                    templateUrl: '/content/settings/account_activation.html',
                    controller: 'AccountActivationController',
                    controllerAs: 'accountActivationController'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                requireCompany: true
            }
        });

         $stateProvider.state('root.private.application.settings.loanerAgreement', {
            abstract: true,
            cache: false,
            views: {
                settingsContent: {
                    templateUrl: '/content/settings/loaner-agreement/index.html',
                    controller: 'SettingsLoanerAgreementController',
                    controllerAs: 'LA'
                }
            }
        });

        $stateProvider.state('root.private.application.settings.loanerAgreement.view', {
            url: '/customer-agreement',
            abstract: false,
            cache: false,
            views: {
                loanerAgreementContent: {
                    controller: 'SettingsLoanerAgreementViewController',
                    controllerAs: 'LAV_Page'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { key: 'view' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.loanerAgreement.upload', {
            url: '/customer-agreement/upload',
            abstract: false,
            cache: false,
            views: {
                loanerAgreementContent: {
                    controller: 'SettingsLoanerAgreementUploadController',
                    controllerAs: 'LAU_Page'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { key: 'upload' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.loanerAgreement.selectPage', {
            url: '/customer-agreement/select-page',
            abstract: false,
            cache: false,
            views: {
                loanerAgreementContent: {
                    controller: 'SettingsLoanerAgreementSelectPageController',
                    controllerAs: 'LASP_Page'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { key: 'select-page' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.loanerAgreement.setSignature', {
            url: '/customer-agreement/set-signature',
            abstract: false,
            cache: false,
            views: {
                loanerAgreementContent: {
                    controller: 'SettingsLoanerAgreementSetSignatureController',
                    controllerAs: 'LASS_Page'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { key: 'set-signature' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.loanerAgreement.setDate', {
            url: '/customer-agreement/set-date',
            abstract: false,
            cache: false,
            views: {
                loanerAgreementContent: {
                    controller: 'SettingsLoanerAgreementSetDateController',
                    controllerAs: 'LASD_Page'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { key: 'set-date' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.loanerAgreementSummary', {
            url: '/customer-agreement/summary',
            abstract: false,
            cache: false,
            views: {
                settingsContent: {
                    templateUrl: '/content/settings/loaner-agreement/summary.html',
                    controller: 'SettingsLoanerAgreementSummaryController',
                    controllerAs: 'settingsLoanerAgreementSummaryController'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { title: 'Driver Agreement Terms' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.fleetUpload', {
            url: '/fleet-upload',
            abstract: false,
            cache: false,
            views: {
              settingsContent: {
                    templateUrl: '/content/settings/fleet-upload.html',
                    controller: 'SettingsFleetUploadController',
                    controllerAs: 'settingsFleetUploadController'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { title: 'Fleet Upload' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.expenses', {
            url: '/expenses',
            abstract: false,
            cache: false,
            views: {
              settingsContent: {
                    templateUrl: '/content/settings/expenses.html',
                    controller: 'SettingsExpensesController',
                    controllerAs: 'settingsExpensesController'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { title: 'Expenses' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.settings.webhooks', {
            url: '/webhooks',
            abstract: false,
            cache: false,
            views: {
                settingsContent: {
                    templateUrl: '/content/settings/webhooks/index.html',
                    controller: 'SettingsWebhooksController',
                    controllerAs: 'settingsWebhooksController'
                }
            },
            data: {
                authorizationRoles: ['admin'],
                page: { title: 'Webhooks' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.reports', {
            url: '/reports',
            abstract: true,
            views: {
                applicationLayoutContent: {
                    template: '<div ui-view="reportsContent"></div>'
                }
            },
        });

        $stateProvider.state('root.private.application.reports.inventory', {
            url: '/inventory',
            abstract: false,
            cache: false,
            views: {
                reportsContent: {
                    templateUrl: '/content/reports/inventory.html',
                    controller: 'ReportsInventoryController',
                    controllerAs: 'reportsInventoryController'
                }
            },
            data: {
                authorizationRoles: ['view_reports'],
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.reports.utilization', {
            url: '/utilization',
            abstract: false,
            cache: false,
            views: {
                reportsContent: {
                    templateUrl: '/content/reports/utilization.html',
                    controller: 'ReportsUtilizationController',
                    controllerAs: 'reportsUtilizationController'
                }
            },
            data: {
                authorizationRoles: ['view_reports'],
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.reports.contracts', {
            url: '/contracts',
            abstract: false,
            cache: false,
            views: {
                reportsContent: {
                    templateUrl: '/content/reports/contracts.html',
                    controller: 'ReportsContractsController',
                    controllerAs: 'reportsContractsController'
                }
            },
            data: {
                authorizationRoles: ['view_reports'],
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.reports.transactions', {
            url: '/transactions',
            abstract: false,
            cache: false,
            views: {
                reportsContent: {
                    templateUrl: '/content/reports/transactions.html',
                    controller: 'ReportsTransactionsController',
                    controllerAs: 'reportsTransactionsController'
                }
            },
            data: {
                authorizationRoles: ['view_reports'],
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.reports.tolls', {
            url: '/tolls',
            abstract: false,
            cache: false,
            views: {
                reportsContent: {
                    templateUrl: '/content/reports/tolls.html',
                    controller: 'ReportsTollsController',
                    controllerAs: 'reportsTollsController'
                }
            },
            data: {
                authorizationRoles: ['view_reports'],
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.training', {
            url: '/training',
            abstract: true,
            views: {
                applicationLayoutContent: {
                    template: '<div ui-view="trainingContent"></div>'
                }
            },
        });

        $stateProvider.state('root.private.application.dashboard', {
            url: '/dashboard',
            abstract: false,
            views: {
                applicationLayoutContent: {
                    templateUrl: '/content/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'dashboardController'
                }
            },
            data: {
                page: { title: 'Dealerware' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.employees', {
            url: '/employees',
            abstract: true,
            views: {
                applicationLayoutContent: { template: '<div ui-view name="employeesContent"></div>' }
            },
            data: {
                page: { title: 'Employees' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.employees.dashboard', {
            url: '/dashboard',
            abstract: false,
            cache: false,
            views: {
                employeesContent: {
                    templateUrl: '/content/employees/employees_dashboard.html',
                    controller: 'EmployeesDashboardController',
                    controllerAs: 'employeesDashboardController'
                }
            },
            data: {
                page: { title: 'Employees' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.employees.details', {
            url: '/details/:employeeId',
            params: { employeeId: null },
            abstract: false,
            views: {
                employeesContent: {
                    templateUrl: '/content/employees/details/employee_details.html',
                    controller: 'EmployeeDetailsController',
                    controllerAs: 'employeeDetailsController'
                }
            },
            data: {
                page: { title: 'Employee Details' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.customers', {
            url: '/customers',
            abstract: true,
            views: {
                applicationLayoutContent: { template: '<div ui-view name="customersContent"></div>' }
            },
            data: {
                page: { title: 'Customers' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.customers.dashboard', {
            url: '/dashboard',
            abstract: false,
            cache: false,
            views: {
                customersContent: {
                    templateUrl: '/content/customers/customers_dashboard.html',
                    controller: 'CustomersDashboardController',
                    controllerAs: 'customersDashboardController'
                }
            },
            data: {
                page: { title: 'Customers' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.customers.details', {
            url: '/details/:customerId/:pageId',
            params: {
                customerId: null,
                pageId: null
            },
            abstract: false,
            views: {
                customersContent: {
                    templateUrl: '/content/customers/details/customer_details.html',
                    controller: 'CustomerDetailsController',
                    controllerAs: 'customerDetailsController'
                }
            },
            data: {
                page: { title: 'Customer Details' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.contracts', {
            url: '/contracts',
            abstract: true,
            views: {
                applicationLayoutContent: { template: '<div ui-view name="contractsContent">' }
            },
            data: {
                page: { title: 'Contracts' },
                requireCompany: true
            }
        });


        $stateProvider.state('root.private.application.contracts.dashboard', {
            url: '/dashboard',
            abstract: false,
            cache: false,
            views: {
                contractsContent: {
                    templateUrl : '/content/contracts/contracts_dashboard.html',
                    controller: 'ContractsDashboardController',
                    controllerAs: 'contractsDashboardController'
                }
            },
            data: {
                page: { title: 'Contracts' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.contracts.details', {
            url: '/details/:contractId',
            abstract: false,
            params: { contractId: null },
            views: {
                contractsContent: {
                    templateUrl: '/content/contracts/details/contract_details.html',
                    controller: 'ContractDetailsController',
                    controllerAs: 'contractDetailsController'
                }
            },
            data: {
                page: { title: 'Contract Details' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.contracts.details.details', {
            url: '/details',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.driversLicense', {
            url: '/drivers-license',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.additionalDrivers', {
            url: '/additional-drivers',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.insurance', {
            url: '/insurance',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.notes', {
            url: '/notes',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.vehicles', {
            url: '/vehicles',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.pricing', {
            url: '/pricing',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.details.vehicleIssues', {
            url: '/vehicle-issues',
            abstract: false,
            cache: false
        });

        $stateProvider.state('root.private.application.contracts.create', {
            url: '/create/:customerId',
            abstract: false,
            params: { customerId: null },
            views: {
                contractsContent: {
                    templateUrl: '/content/contracts/create/create_contract.html',
                    controller: 'CreateContractController',
                    controllerAs: 'createContractController'
                }
            },
            data: {
                page: { title: 'Create Contract' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.contracts.confirmation', {
            url: '/confirmation/:contractId',
            abstract: false,
            params: { contractId: null },
            views: {
                contractsContent: {
                    templateUrl: '/content/contracts/create/contract_confirmation.html',
                    controller: 'ContractConfirmationController',
                    controllerAs: 'contractConfirmationController'
                }
            },
            data: {
                page: { title: 'Contract Confirmed' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.vehicles', {
            url: '/vehicles',
            abstract: true,
            views: {
                applicationLayoutContent: { template: '<div ui-view name="vehiclesContent">' }
            },
            data: {
                page: { title: 'Vehicles' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.vehicles.dashboard', {
            url: '/dashboard',
            abstract: false,
            cache: false,
            params: { searchText: null },
            views: {
                vehiclesContent: {
                    templateUrl : '/content/vehicles/vehicles_dashboard.html',
                    controller: 'VehiclesDashboardController',
                    controllerAs: 'vehiclesDashboardController'
                }
            },
            data: {
                page: { title: 'Vehicles' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.vehicles.details', {
            url: '/details/:vehicleId',
            abstract: false,
            params: { vehicleId: null },
            views: {
                vehiclesContent: {
                    templateUrl: '/content/vehicles/details/vehicle_details.html',
                    controller: 'VehicleDetailsController',
                    controllerAs: 'vehicleDetailsController'
                }
            },
            data: {
                page: { title: 'Vehicle Details' },
                requireCompany: true
            }
        });

        $stateProvider.state('root.private.application.vehicles.qrcodes', {
            url: '/qrcodes',
            abstract: false,
            views: {
                vehiclesContent: {
                    templateUrl: '/content/vehicles/qr_codes/print.html',
                    controller: 'QrCodesPrintController',
                    controllerAs: 'qrCodesPrintController'
                }
            },
            data: {
                requireCompany: true
            }
        });

        $stateProvider.state('external', {
            abstract: true
        });

        // Fake routes.  Keeping this data here since it seems like a logical place rather than
        // having links and URLs embedded throughout the rest of the code.
        //
        // The way these are used: the routes are not literally embedded in ui-srefs, but
        // are instead used to look up the URLs and parameters to be used in normal hrefs,
        // which is how we have to do things when dealing with external sites that open in
        // their own windows, where we can't use the ui-srefs since all normal routing URL
        // fragments are treated as internal routes.
        //
        $stateProvider.state('external.dealerwareHelp', {
            abstract: false,
            data: {
                url         : 'https://support.dealerware.com/hc',
                absoluteUrl : true,
                newWindow   : true
            }
        });

        $stateProvider.state('external.dealerwareAcademy', {
            abstract: false,
            data: {
                url : (stateArgs) => 'https://dealerware.schoolkeep.com?first_name='
                    + stateArgs().firstName
                    + "&last_name=" + stateArgs().lastName
                    + "&email=" + stateArgs().email,
                absoluteUrl : true,
                newWindow   : true
            }
        });

        $stateProvider.state('external.dealerwareContactUs', {
            abstract: false,
            data: {
                url         : 'https://support.dealerware.com/hc/en-us/requests/new',
                absoluteUrl : true,
                newWindow   : true
            }
        });

        $stateProvider.state('external.dealerwarePlaceOrder', {
            abstract: false,
            data: {
                url : (stateArgs) => 'https://dealerware.formstack.com/forms/order?name-first='
                    + stateArgs().firstName
                    + "&name-last=" + stateArgs().lastName
                    + "&email=" + stateArgs().email
                    + "&dealership_name=" + stateArgs().dealershipName
                    + "&dealership_id=" + stateArgs().dealershipId,
                absoluteUrl : true,
                newWindow   : true
            }
        });

        // Setup the default state
        $urlRouterProvider.otherwise(_defaultState);
    })
    .run( [ 'routeShortcuts', 'reverseRouteShortcuts', function (routeShortcuts, reverseRouteShortcuts) {

        Object.keys(routeShortcuts).forEach( function (shortcut) {
            reverseRouteShortcuts[routeShortcuts[shortcut].target] = shortcut;
        });
    }]);
})();
